export const SET_SELECTED_CARD_REQUEST_ID = 'SET_SELECTED_CARD_REQUEST_ID';
export class SetSelectedCardRequestId {
    constructor(payload) {
        this.payload = payload;
        this.type = SET_SELECTED_CARD_REQUEST_ID;
    }
}
